import styles from './Inicio.module.css';
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import ParticlesBackground from '../../components/ParticlesBackground/ParticlesBackground';
import { useTranslation } from 'react-i18next';
import PageSEO from '../../components/PageSEO/PageSEO';

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.13 } }
};

const reveal = {
  hidden: { opacity: 0, y: 22 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] } }
};

function Inicio({ setActiveMenu }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.slice(0, 2) || 'pt';
  const go = (id) => { setActiveMenu(id); navigate('/' + id); };

  const products = [
    {
      id: 'Elohim',
      name: 'Elohim',
      desc: t('inicio.elohimDesc'),
      accent: '#00c853',
    },
    {
      id: 'Sanarix',
      name: 'Sanarix',
      desc: t('inicio.sanarixDesc'),
      accent: '#2196f3',
    },
    {
      id: 'NotaFiscal',
      name: 'SteinNFe',
      desc: t('inicio.notafiscalDesc'),
      accent: '#00e676',
    },
    {
      id: 'TIPresencial',
      name: 'T.I Presencial',
      desc: t('inicio.tiPresencialDesc'),
      accent: '#fbbf24',
    },
  ];

  return (
    <div className={styles.page}>
      <PageSEO
        title="Soluções em Software"
        description="SteinSoft — Tecnologia feita por pessoas, para pessoas. Desenvolvimento de software sob medida, consultoria em TI, DevOps e produtos próprios: Elohim, Sanarix e Simão."
        path="/"
        lang={lang}
      />

      <div className={styles.particles}>
        <ParticlesBackground />
      </div>

      {/* ── Hero ── */}
      <motion.section
        className={styles.hero}
        variants={stagger}
        initial="hidden"
        animate="visible"
      >
        <motion.span className={styles.eyebrow} variants={reveal}>
          {t('inicio.eyebrow')}
        </motion.span>

        <motion.h1 className={styles.headline} variants={reveal}>
          {t('inicio.titulo')}<br />
          <span className={styles.gradientText}>{t('inicio.tituloDest')}</span>
        </motion.h1>

        <motion.p className={styles.tagline} variants={reveal}>
          {t('inicio.subtitulo')}
        </motion.p>

        <motion.div className={styles.actions} variants={reveal}>
          <button className={styles.btnPrimary} onClick={() => go('Servicos')}>
            {t('inicio.btnSolucoes')}
          </button>
          <button className={styles.btnGhost} onClick={() => go('Contato')}>
            {t('inicio.btnContato')}
          </button>
        </motion.div>
      </motion.section>

      {/* ── Product showcase ── */}
      <div className={styles.showcase}>
        {products.map((p, i) => (
          <motion.div
            key={p.id}
            className={styles.card}
            style={{ '--accent': p.accent }}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.55 + i * 0.13, ease: [0.22, 1, 0.36, 1] }}
            onClick={() => go(p.id)}
          >
            <span className={styles.cardName}>{p.name}</span>
            <span className={styles.cardDesc}>{p.desc}</span>
            <span className={styles.cardArrow}>→</span>
          </motion.div>
        ))}
      </div>

    </div>
  );
}

export default Inicio;
